import { ISearchParameters, ITableReport } from "./TableInterfaces";

export interface IOptionGreekSearchParam extends ISearchParameters {
  baseInsId: string;
  dueDate: string;
  blackSholtzDeviationPercentage: number | null;
  tradeValue: string;
  remainingDays: string;
  status: string;
  minValue: string;
  fromDelta: number | null;
  toDelta: number | null;
  fromRemainingDay: number | null;
  toRemainingDay: number | null;
  optionType: OptionGreekOptionType;
}

export interface IOptionGreekConstraintSearchParam extends ISearchParameters {
  baseInsId: string;
}

export interface IOptionsGreekTableReport extends ITableReport {
  callInstrument: string;
  callInstrumentCode: string;
  baseInstrument: string;
  dueDate: string;
}

export interface IOptionsGreekConstraintTableReport extends ITableReport {
  instrument: string;
  instrumentId: string;
  volatilityBaseIns: string;
  dividendYield: string;
}

export interface IOptionGreekConstraintFormValues {
  id: number;
  baseInsId: string;
  dividendYield: number;
  volatilityBaseIns: number;
}

export enum OptionGreekOptionType {
  Call = 1,
  Put = 2,
}

export interface IChartCommonSearchParam {
  headerName: string;
  insCode: string;
  insName: string;
  fromTime: string;
  toTime: string;
  date: string;
}
